/* Homepage Spring Drop hero (sections/hha-home-spring-hero.liquid). GENERATED by hero/extract.mjs from the approved,
   live assets/spring-drop.js. Only what the hero needs: the setup lines it reads (root, page, tokens, reduced motion,
   the header section) and the phone hero 7 block, copied verbatim. The landing's product data, size picker, cart and
   grid code are not here, so this runs without #sp-data or #sp-pick. Do not hand-edit; re-run the script.
   Changes from the source:
   - heading <h1> becomes <h2> (the header renders the wordmark as the h1 when template.name == "index"); the CSS selectors .sp-hero-copy h1 follow it to h2
   - pill href "#pieces" becomes "/collections/spring-drop"
   - reduced motion: html[data-motion="always"] overrides the OS setting (CSS block and the JS reduced() test). Only the review preview ever sets it
   - CSS and JS keep only the hero, its wrapper, the pay line and the see-through header rules; nothing else from the landing page */
(() => {
  'use strict';
  const root = document.querySelector('.sp-root');
  if (!root) return;
  const page = root.querySelector('.sp-page');
  if (!page) return;

  // motion values live in the section's tokens (scoped to .sp-root); read them once
  const css = getComputedStyle(root);
  const doc = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  // html[data-motion="always"] is set only by the review preview (?motion=always) so a reviewer whose OS reports reduced
  // motion still sees the motion under review. The live homepage never sets it, so there this is the OS setting alone.
  const reduced = () => doc.dataset.motion !== 'always' && reduce.matches;
  // the live theme's header section (sections/header.liquid): sticky, announcement + ink bar, rendered outside the page
  const hdrSec = document.getElementById('shopify-section-header');

  /* ---------------- phone hero 7 (round 8, approved round 9 as the HHA collection-hero pattern; wiki
     concepts/hha-mobile-hero-shrink-on-scroll.md). No pin, no held scroll: the page scrolls normally from the first
     pixel. On load the photo fills the whole screen behind the see-through live header; over the first --m-h7-span of
     the hero's height it shrinks into the framed card while the header's ground fades in. p = scrollY / span. Per frame:
     transform on stage, photo and copy; opacity on the header ground and the scrim. Sizes are measured once per layout
     (lvh, so the iOS address bar changes nothing). Runs only under 560px and never under reduced motion: those visitors
     get the framed end state and a solid header from the first frame.
     Live-theme wiring: the header ground is one overlay (.hh-h7bg) this script puts inside #shopify-section-header, the
     header section's whole height is measured (it can carry app-injected bars), and the page is pulled up under the
     header by the header section's own negative margin (spring-drop.css), so the Venture page container never clips it. */
  const stage = page.querySelector('.sp-stage');
  const h7 = (() => {
    const heroEl = page.querySelector('.sp-hero');
    const shot = heroEl.querySelector('.sp-shot'), copy = heroEl.querySelector('.sp-hero-copy'), scrim = heroEl.querySelector('.sp-h7-scrim');
    const xt = heroEl.querySelector('.sp-hero-xtall');
    let bg = null;
    if (hdrSec) {
      bg = hdrSec.querySelector(':scope > .hh-h7bg');
      if (!bg) { bg = document.createElement('div'); bg.className = 'hh-h7bg'; bg.setAttribute('aria-hidden', 'true'); hdrSec.prepend(bg); }
    }
    const num = n => parseFloat(css.getPropertyValue(n));
    const SPAN = num('--m-h7-span') || 0.4, ZOOM = num('--m-h7-zoom') || 1.04;
    const VARS = ['--h7-top', '--h7-e', '--h7-shot-h'];
    const clamp = v => Math.min(1, Math.max(0, v));
    const smooth = v => v * v * (3 - 2 * v);
    const f = v => +v.toFixed(3);
    const probe = h => { const d = document.createElement('div'); d.style.cssText = 'position:absolute;left:-99px;top:0;width:1px;visibility:hidden;height:' + h; document.body.appendChild(d); const v = d.offsetHeight; d.remove(); return v; };
    const st = { on: false, g: null, p: -1, raf: 0 };
    const wanted = () => !!xt && !reduced() && page.clientWidth < 560;

    function measure() {
      const W = page.clientWidth, top = hdrSec ? hdrSec.getBoundingClientRect().height : 0;
      const i = num('--hero-inset') || 6, r = num('--hero-radius') || 10;
      const w = W - 2 * i, h = w * 750 / 390; // the framed card (its stage is aspect-ratio 390/750)
      const shotH = w * (+xt.getAttribute('height') / +xt.getAttribute('width')), E = shotH - h; // the tall crop plus the drape strip E on top
      const lv = Math.max(probe('100lvh') || 0, innerHeight), T0 = top + i; // the card's top on the page (and on screen at scroll 0)
      // the window the stage opens out to at p = 0: the full screen width, and past the top and bottom edges by more than a
      // (scaled) corner, so no rounded corner is on screen at load
      const m = Math.ceil(r * 1.5) + 2;
      const win = { x: -i, y: -T0 - m, w: W, h: lv + 2 * m };
      // Port fix, not in the prototype: the drape strip on top of the crop was sized for a 390x844 screen, where the photo
      // is height-bound and the headline lands just under the header. On short phones (320x568, 360x640, 375x667) the
      // photo is width-bound, so the copy riding on it ended up behind the see-through header, the eyebrow over the
      // wordmark (the prototype does the same). There the photo and copy open out a little further (same composition,
      // uniformly larger) so the eyebrow's box never tucks more than COPY_TUCK px under the header bar. At 390x844 and
      // every taller phone the need is below the original scale, so nothing changes there.
      const COPY_TUCK = 8;
      const pad = parseFloat(getComputedStyle(copy).paddingTop) || 0;
      const sNeed = (top - COPY_TUCK + m) / (E + pad);
      const s0 = Math.max(win.w / w, win.h / shotH, sNeed);
      const fig = xt.dataset.figure.split(',').map(Number); // the model's box in the crop: [x0, y0, x1, y1]
      const set = (k, v) => doc.style.setProperty(k, f(v) + 'px');
      set('--h7-top', top); set('--h7-e', E); set('--h7-shot-h', shotH); // first, so the hero's height below includes its top padding
      st.g = { W, i, r, w, h, E, shotH, lv, T0, m, win, s0, tx0: (W - s0 * w) / 2 - i, ty0: win.y + E * s0,
        ax: w * (fig[0] + fig[2]) / 2, ay: shotH * fig[3] - E, D: Math.max(1, Math.round(heroEl.offsetHeight * SPAN)) };
    }
    // p = 0: the whole screen. p = 1: exactly the framed card (every transform identity).
    function apply(p) {
      const g = st.g; p = clamp(p);
      if (p === st.p) return;
      st.p = p;
      const q = 1 - p;
      const Lx = g.win.x * q, Ly = g.win.y * q, sx = (g.w + (g.win.w - g.w) * q) / g.w, sy = (g.h + (g.win.h - g.h) * q) / g.h;
      stage.style.transform = p >= 1 ? 'none' : `translate(${f(Lx)}px, ${f(Ly)}px) scale(${sx.toFixed(5)}, ${sy.toFixed(5)})`;
      const s = 1 + (g.s0 - 1) * q, z = 1 + (ZOOM - 1) * q;
      const base = `translate(${f(g.tx0 * q)}px, ${f(g.ty0 * q)}px) scale(${s.toFixed(5)})`;
      const photo = `${base} translate(${f(g.ax)}px, ${f(g.ay)}px) scale(${z.toFixed(5)}) translate(${f(-g.ax)}px, ${f(-g.ay)}px)`;
      shot.style.transform = p >= 1 ? 'none' : `scale(${(1 / sx).toFixed(5)}, ${(1 / sy).toFixed(5)}) translate(${f(-Lx)}px, ${f(-Ly)}px) ${photo}`;
      copy.style.transform = p >= 1 ? 'none' : base;
      // the header's ground is fully in by a quarter of the way, before the headline scrolls up under it
      const b = smooth(clamp((p - 0.02) / 0.23));
      if (bg) bg.style.opacity = b.toFixed(3);
      scrim.style.opacity = (1 - b).toFixed(3);
      if ((p >= 1) !== doc.hasAttribute('data-h7done')) doc.toggleAttribute('data-h7done', p >= 1);
    }
    function frame() { st.raf = 0; if (st.on) apply(scrollY / st.g.D); }
    addEventListener('scroll', () => { if (st.on && !st.raf) st.raf = requestAnimationFrame(frame); }, { passive: true });

    function enable() { st.on = true; doc.dataset.h7 = 'on'; measure(); st.p = -1; apply(scrollY / st.g.D); }
    function disable() {
      st.on = false;
      delete doc.dataset.h7; doc.removeAttribute('data-h7done');
      shot.style.transform = ''; copy.style.transform = ''; stage.style.transform = ''; scrim.style.opacity = '';
      if (bg) bg.style.opacity = '';
      VARS.forEach(k => doc.style.removeProperty(k));
    }
    function sync() {
      const w = wanted();
      if (w && !st.on) enable();
      else if (!w && st.on) disable();
      else if (st.on) { measure(); st.p = -1; apply(scrollY / st.g.D); }
    }
    addEventListener('resize', () => { if (st.on || wanted()) sync(); });
    if (hdrSec && 'ResizeObserver' in window) new ResizeObserver(() => { if (st.on) sync(); }).observe(hdrSec);
    reduce.addEventListener?.('change', sync);
    document.fonts && document.fonts.ready.then(() => { if (st.on) sync(); });
    addEventListener('load', () => { if (st.on) sync(); });
    sync();
    return { sync, state: () => ({ on: st.on, p: st.p, g: st.g }) };
  })();

  // handle for the verification script
  window.HHHomeSpringHero = { h7 };
})();
